var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.505951,
    width: 31,
    height: 30.9881,
    rx: 15.4941,
    stroke: "#F84545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90003 23.4281C12.022 21.9627 13.4405 19.7236 14.4838 16.9803C15.5389 14.2488 16.6644 11.9041 16.172 9.20774C16.1017 8.7857 15.5038 8.35194 15.199 8.38711C14.0032 8.45745 14.0853 9.80563 14.2025 10.6145C14.4838 12.6192 16.0313 14.9522 17.5319 17.1327C19.0208 19.325 20.2517 19.6649 21.9633 19.7822C22.5495 19.8173 23.4287 19.618 23.5694 19.1022C24.4721 15.8197 12.995 18.4692 9.17318 21.5407C8.70425 21.9275 8.16498 22.713 8.46979 23.2523C8.70425 23.6743 9.48971 23.7212 9.91175 23.4281H9.90003Z",
    stroke: "#F84545",
    strokeWidth: 1.17233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeicon);
export default __webpack_public_path__ + "static/media/Themeicon.414c494e72722fe21bc65c6aa1ddb877.svg";
export { ForwardRef as ReactComponent };